var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoGatewaySmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.016 60.016L41.48 55.752C42.104 55.096 42.536 54.176 41.264 53.44L22.328 42.504L22.264 42.464C20.464 41.432 18.224 41.736 16.416 42.776C14.608 43.816 13.936 45.192 15.72 46.248L34.768 57.216C34.768 57.216 36.624 58.056 39.056 57.232L46.544 61.456C46.544 61.456 47.528 61.904 48.688 61.232C48.688 61.232 49.88 60.52 49.016 60.016Z",
    fill: "url(#paint0_linear_2317_204440)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.088 35.832C42.088 28.848 37.184 20.36 31.144 16.872C28.088 15.112 25.328 14.96 23.344 16.144L18.104 19.176L20.208 22.928C20.208 23.016 20.208 23.104 20.208 23.192C20.208 30.064 24.96 38.392 30.88 41.976L33.232 46.184L38.848 42.944C40.856 41.808 42.096 39.352 42.096 35.832H42.088Z",
    fill: "url(#paint1_linear_2317_204440)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3561 46.1127C37.6302 43.6451 37.6296 35.6426 33.3549 28.2386C29.0803 20.8347 22.1502 16.8329 17.8761 19.3006C13.6021 21.7682 13.6026 29.7707 17.8773 37.1746C22.152 44.5786 29.0821 48.5803 33.3561 46.1127Z",
    fill: "url(#paint2_linear_2317_204440)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5321 44.6855C36.3508 42.4807 36.3501 35.3303 32.5305 28.7146C28.7109 22.0988 22.5188 18.523 18.7001 20.7277C14.8814 22.9324 14.8822 30.0828 18.7018 36.6986C22.5214 43.3143 28.7134 46.8902 32.5321 44.6855Z",
    fill: "#EDECED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4081 46.0801L33.3041 46.1361C33.3041 46.1361 33.3761 46.0961 33.4081 46.0801Z",
    fill: "#9D9D9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3601 44.7281C30.6961 45.2641 28.6001 44.9441 26.3281 43.6321C20.8961 40.4961 16.4881 32.8641 16.4881 26.5921C16.4881 23.7841 17.3761 21.7201 18.8401 20.5841C18.8961 20.5441 18.9521 20.4961 19.0081 20.4561C18.9441 20.4881 18.8881 20.5201 18.8241 20.5441C16.9281 21.5201 15.7361 23.7681 15.7361 27.0161C15.7361 33.2881 20.1441 40.9201 25.5761 44.0561C28.2321 45.5921 30.6401 45.7601 32.4081 44.8081C32.5761 44.7201 32.7361 44.6161 32.8961 44.5121C32.7201 44.5921 32.5441 44.6561 32.3601 44.7201V44.7281Z",
    fill: "url(#paint3_linear_2317_204440)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3281 43.6401C20.8961 40.5041 16.4881 32.8721 16.4881 26.6001C16.4881 23.7921 17.3761 21.7281 18.8401 20.5921C18.8961 20.5521 18.9521 20.5041 19.0081 20.4641C18.9441 20.4961 18.8881 20.5281 18.8241 20.5521C16.9281 21.5281 15.7361 23.7761 15.7361 27.0241C15.7361 33.2961 20.1441 40.9281 25.5761 44.0641C28.2321 45.6001 30.6401 45.7681 32.4081 44.8161C32.5761 44.7281 32.7361 44.6241 32.8961 44.5201C32.7201 44.6001 32.5441 44.6641 32.3601 44.7281C30.6961 45.2641 28.6001 44.9441 26.3281 43.6321V43.6401Z",
    fill: "url(#paint4_linear_2317_204440)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.408 27.184C36.264 27.144 36.104 27.048 35.968 26.896C35.712 26.616 35.64 26.264 35.808 26.112L47.152 19.504C47.32 19.352 47.664 19.456 47.92 19.744C48.176 20.024 48.248 20.376 48.08 20.528L36.736 27.136C36.656 27.208 36.544 27.224 36.416 27.184H36.408Z",
    fill: "#D6D6D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.52 40.2081C38.56 40.0641 38.664 39.9041 38.816 39.7681C39.104 39.5201 39.456 39.4561 39.608 39.6241L46.456 48.0081C46.608 48.1761 46.488 48.5201 46.2 48.7681C45.912 49.0161 45.56 49.0801 45.408 48.9121L38.56 40.5281C38.488 40.4481 38.48 40.3281 38.512 40.2001L38.52 40.2081Z",
    fill: "#D6D6D6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.448 17.0241C24.368 17.1521 24.224 17.2721 24.04 17.3601C23.696 17.5201 23.336 17.4801 23.24 17.2721L17.464 5.11206C17.368 4.90406 17.576 4.60806 17.92 4.45606C18.264 4.29606 18.624 4.33606 18.72 4.54406L24.496 16.7041C24.536 16.8001 24.52 16.9121 24.448 17.0241Z",
    fill: "#D6D6D6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M49.32 50.12C49.32 48.168 47.952 45.792 46.256 44.816C45.4 44.32 44.632 44.28 44.072 44.608L42.608 45.456L43.192 46.504C43.192 46.504 43.192 46.552 43.192 46.576C43.192 48.496 44.52 50.824 46.176 51.832L46.832 53.008L48.4 52.104C48.96 51.784 49.312 51.096 49.312 50.112L49.32 50.12Z",
    fill: "url(#paint5_linear_2317_204440)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8807 52.9912C48.0745 52.302 48.0735 50.0651 46.8783 47.9951C45.6832 45.925 43.7465 44.8057 42.5527 45.4949C41.3589 46.1842 41.36 48.421 42.5551 50.4911C43.7503 52.5611 45.6869 53.6805 46.8807 52.9912Z",
    fill: "url(#paint6_linear_2317_204440)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6669 52.5993C47.7399 51.9748 47.736 49.9671 46.6581 48.1151C45.5801 46.2631 43.8365 45.268 42.7634 45.8925C41.6904 46.517 41.6944 48.5247 42.7723 50.3767C43.8502 52.2287 45.5939 53.2238 46.6669 52.5993Z",
    fill: "#EDECED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.616 52.592C46.152 52.744 45.568 52.656 44.928 52.288C43.408 51.416 42.176 49.288 42.176 47.536C42.176 46.752 42.424 46.176 42.832 45.864C42.848 45.856 42.864 45.84 42.88 45.832C42.864 45.832 42.848 45.848 42.832 45.856C42.304 46.128 41.968 46.752 41.968 47.664C41.968 49.416 43.2 51.544 44.72 52.416C45.464 52.84 46.136 52.888 46.632 52.624C46.68 52.6 46.728 52.568 46.768 52.544C46.72 52.568 46.672 52.584 46.616 52.6V52.592Z",
    fill: "url(#paint7_linear_2317_204440)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.928 52.288C43.408 51.416 42.176 49.288 42.176 47.536C42.176 46.752 42.424 46.176 42.832 45.864C42.848 45.856 42.864 45.84 42.88 45.832C42.864 45.832 42.848 45.848 42.832 45.856C42.304 46.128 41.968 46.752 41.968 47.664C41.968 49.416 43.2 51.544 44.72 52.416C45.464 52.84 46.136 52.888 46.632 52.624C46.68 52.6 46.728 52.568 46.768 52.544C46.72 52.568 46.672 52.584 46.616 52.6C46.152 52.752 45.568 52.664 44.928 52.296V52.288Z",
    fill: "url(#paint8_linear_2317_204440)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7201 9.392C23.7201 7.44 22.3521 5.064 20.6561 4.088C19.8001 3.592 19.0321 3.552 18.4721 3.88L17.0081 4.728L17.5921 5.776C17.5921 5.776 17.5921 5.824 17.5921 5.848C17.5921 7.768 18.9201 10.096 20.5761 11.104L21.2321 12.28L22.8001 11.376C23.3601 11.056 23.7121 10.368 23.7121 9.384L23.7201 9.392Z",
    fill: "url(#paint9_linear_2317_204440)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2755 12.2598C22.4693 11.5705 22.4682 9.33368 21.2731 7.26363C20.0779 5.19358 18.1413 4.07422 16.9475 4.76348C15.7537 5.45273 15.7547 7.68958 16.9499 9.75963C18.145 11.8297 20.0817 12.949 21.2755 12.2598Z",
    fill: "url(#paint10_linear_2317_204440)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0515 11.8718C22.1228 11.2533 22.1228 9.24744 21.0514 7.39166C19.9799 5.53589 18.2428 4.53293 17.1715 5.15148C16.1001 5.77004 16.1001 7.77589 17.1716 9.63166C18.243 11.4874 19.9801 12.4904 21.0515 11.8718Z",
    fill: "#EDECED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.008 11.864C20.544 12.016 19.96 11.928 19.328 11.56C17.816 10.688 16.584 8.56 16.584 6.808C16.584 6.024 16.832 5.448 17.24 5.136C17.256 5.128 17.272 5.112 17.288 5.104C17.272 5.104 17.256 5.12 17.24 5.128C16.712 5.4 16.376 6.024 16.376 6.936C16.376 8.688 17.608 10.816 19.12 11.688C19.864 12.112 20.536 12.16 21.024 11.896C21.072 11.872 21.12 11.84 21.16 11.816C21.112 11.84 21.064 11.856 21.008 11.872V11.864Z",
    fill: "url(#paint11_linear_2317_204440)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.328 11.56C17.816 10.688 16.584 8.56 16.584 6.808C16.584 6.024 16.832 5.448 17.24 5.136C17.256 5.128 17.272 5.112 17.288 5.104C17.272 5.104 17.256 5.12 17.24 5.128C16.712 5.4 16.376 6.024 16.376 6.936C16.376 8.688 17.608 10.816 19.12 11.688C19.864 12.112 20.536 12.16 21.024 11.896C21.072 11.872 21.12 11.84 21.16 11.816C21.112 11.84 21.064 11.856 21.008 11.872C20.544 12.024 19.96 11.936 19.328 11.568V11.56Z",
    fill: "url(#paint12_linear_2317_204440)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2719 20.9602C53.2719 18.1682 51.3119 14.7762 48.8959 13.3842C47.6799 12.6802 46.5759 12.6242 45.7759 13.0962L43.6799 14.3042L44.5199 15.8002C44.5199 15.8002 44.5199 15.8722 44.5199 15.9042C44.5199 18.6482 46.4159 21.9762 48.7839 23.4082L49.7279 25.0882L51.9759 23.7922C52.7759 23.3362 53.2719 22.3522 53.2719 20.9522V20.9602Z",
    fill: "url(#paint13_linear_2317_204440)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7879 25.0707C51.4944 24.0854 51.4935 20.8889 49.7859 17.9312C48.0782 14.9734 45.3104 13.3744 43.6039 14.3597C41.8973 15.345 41.8983 18.5414 43.6059 21.4992C45.3136 24.4569 48.0813 26.056 49.7879 25.0707Z",
    fill: "url(#paint14_linear_2317_204440)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5238 24.6135C51.085 23.7121 51.0844 20.7884 49.5226 18.0832C47.9607 15.378 45.429 13.9156 43.8678 14.817C42.3067 15.7183 42.3073 18.642 43.8691 21.3472C45.431 24.0524 47.9627 25.5148 49.5238 24.6135Z",
    fill: "#EDECED"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4399 24.5841C48.7679 24.8001 47.9119 24.6721 46.9919 24.1441C44.7839 22.8721 42.9999 19.7761 42.9999 17.2321C42.9999 16.0881 43.3599 15.2561 43.9519 14.7921C43.9759 14.7761 43.9999 14.7601 44.0159 14.7441C43.9919 14.7521 43.9679 14.7681 43.9439 14.7841C43.1759 15.1761 42.6959 16.0881 42.6959 17.4081C42.6959 19.9521 44.4799 23.0481 46.6879 24.3201C47.7679 24.9441 48.7439 25.0161 49.4639 24.6241C49.5359 24.5841 49.5999 24.5441 49.6639 24.5041C49.5919 24.5361 49.5199 24.5601 49.4479 24.5841H49.4399Z",
    fill: "url(#paint15_linear_2317_204440)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9919 24.1441C44.7839 22.8721 42.9999 19.7761 42.9999 17.2321C42.9999 16.0881 43.3599 15.2561 43.9519 14.7921C43.9759 14.7761 43.9999 14.7601 44.0159 14.7441C43.9919 14.7521 43.9679 14.7681 43.9439 14.7841C43.1759 15.1761 42.6959 16.0881 42.6959 17.4081C42.6959 19.9521 44.4799 23.0481 46.6879 24.3201C47.7679 24.9441 48.7439 25.0161 49.4639 24.6241C49.5359 24.5841 49.5999 24.5441 49.6639 24.5041C49.5919 24.5361 49.5199 24.5601 49.4479 24.5841C48.7759 24.8001 47.9199 24.6721 46.9999 24.1441H46.9919Z",
    fill: "url(#paint16_linear_2317_204440)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2317_204440",
    x1: 15.816,
    y1: 42.52,
    x2: 48.768,
    y2: 61.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565656",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2317_204440",
    x1: 23.432,
    y1: 40.536,
    x2: 35.608,
    y2: 19.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2317_204440",
    x1: 14.6735,
    y1: 32.7087,
    x2: 36.5615,
    y2: 32.7087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B8B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2317_204440",
    x1: 15.7361,
    y1: 32.9441,
    x2: 32.8961,
    y2: 32.9441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2317_204440",
    x1: 15.7361,
    y1: 32.9441,
    x2: 32.8961,
    y2: 32.9441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2317_204440",
    x1: 44.104,
    y1: 51.432,
    x2: 47.512,
    y2: 45.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2317_204440",
    x1: 41.6514,
    y1: 49.2474,
    x2: 47.7714,
    y2: 49.2474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B8B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2317_204440",
    x1: 41.96,
    y1: 49.304,
    x2: 46.768,
    y2: 49.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2317_204440",
    x1: 41.96,
    y1: 49.304,
    x2: 46.768,
    y2: 49.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2317_204440",
    x1: 18.5041,
    y1: 10.704,
    x2: 21.9121,
    y2: 4.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2317_204440",
    x1: 16.0548,
    y1: 8.51155,
    x2: 22.1748,
    y2: 8.51155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B8B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2317_204440",
    x1: 16.376,
    y1: 8.576,
    x2: 21.16,
    y2: 8.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2317_204440",
    x1: 16.376,
    y1: 8.576,
    x2: 21.16,
    y2: 8.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2317_204440",
    x1: 45.8239,
    y1: 22.8402,
    x2: 50.6879,
    y2: 14.4162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2317_204440",
    x1: 42.3214,
    y1: 19.7179,
    x2: 51.0734,
    y2: 19.7179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B8B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2317_204440",
    x1: 42.6959,
    y1: 19.8081,
    x2: 49.6559,
    y2: 19.8081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2317_204440",
    x1: 42.6959,
    y1: 19.8081,
    x2: 49.6559,
    y2: 19.8081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGatewaySmall);
export default __webpack_public_path__ + "static/media/no_gateway_small.27b5f338eda64ddbdb1595c2539722cc.svg";
export { ForwardRef as ReactComponent };